import { useContext } from 'react';
import AuthContext from './AuthContext.jsx';

export function useAuth() {
    // Remove or comment out the debug log to avoid continuous console output
    // console.log('ctx', ctx);
    const ctx = useContext(AuthContext);
    return ctx;
}
export default useAuth;